// ABOUTME: Renders the chained configurator drawer and the saving backdrop of useCatalogConfiguratorAction.
// ABOUTME: Shared by the model-selection catalog and the list widgets configured with itemAction open-configurator.

import { ChainedConfiguratorFlow } from '@src/_new/modules/cpq/components/OfferLineItems/ChainedConfiguratorFlow';

import { useCatalogConfiguratorAction } from '../hooks/useCatalogConfiguratorAction';
import { SavingOverlay } from './SavingOverlay';

interface CatalogConfiguratorHostProps {
    action: ReturnType<typeof useCatalogConfiguratorAction>;
    offerId?: string;
    /** Shows the favorite star for the configured prototype in the drawer header. */
    enableFavoriteAction?: boolean;
}

export function CatalogConfiguratorHost({
    action,
    offerId,
    enableFavoriteAction,
}: CatalogConfiguratorHostProps) {
    return (
        <>
            {/* The single drawer of the configuration chain: it renders the current step with its
                stepper and Back/Next/Save actions. */}
            <ChainedConfiguratorFlow
                flow={action.chainedFlow}
                offerId={offerId}
                enableFavoriteAction={enableFavoriteAction}
            />

            {/* Bridges the save's network wait, which has no dialog of its own: the configurator is
                closed before the item is persisted and the page navigates/refreshes. */}
            {action.isSaving && <SavingOverlay />}
        </>
    );
}
